import { render, staticRenderFns } from "./Homenajeados.vue?vue&type=template&id=1d6cfd0e&"
import script from "./Homenajeados.vue?vue&type=script&lang=js&"
export * from "./Homenajeados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports